export default {
  title: 'Bezorgadres',
  buttons: {
    save: 'Opslaan',
  },
};
